// <s-scroll-header> keeps the site header sticky, slides it out of view while the shopper
// scrolls down the page, and brings it back as soon as they scroll up.
// It moves the header with `top` (not transform) so fixed-position menus inside it keep working.
class ScrollHeader extends HTMLElement {
  #lastY = 0;
  #ticking = false;
  #hidden = false;
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    this.#lastY = window.scrollY;
    window.addEventListener("scroll", () => this.#queue(), { passive: true, signal: this.#controller.signal });
    this.addEventListener("focusin", () => this.#show(), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #queue() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#update();
      this.#ticking = false;
    });
  }

  #update() {
    const y = Math.max(window.scrollY, 0);
    const delta = y - this.#lastY;
    const menuOpen = this.querySelector("dialog[open], [aria-expanded='true']");

    if (y <= this.offsetHeight || menuOpen) {
      this.#show();
    } else if (delta > 6) {
      this.#hide();
    } else if (delta < -6) {
      this.#show();
    }
    this.#lastY = y;
  }

  #hide() {
    if (this.#hidden) return;
    this.#hidden = true;
    this.style.top = `-${this.offsetHeight}px`;
    this.dataset.state = "hidden";
  }

  #show() {
    if (!this.#hidden) return;
    this.#hidden = false;
    this.style.top = "0px";
    this.dataset.state = "visible";
  }
}

if (!customElements.get("s-scroll-header")) {
  customElements.define("s-scroll-header", ScrollHeader);
}
